module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplement-types text-dark",
    class: {
      'supplement-types--full': _vm.isInOpusModal
    }
  }, [_c('div', {
    staticClass: "supplement-types__header"
  }, [_c('div', {
    staticClass: "supplement-types__header__left"
  }, [_c('h2', [_vm._v("Faste tillæg")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header__left"
  }, [(!_vm.isInOpusModal) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsCreateModal(true)
      }
    }
  }, [_vm._v("Opret tillæg")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header"
  }, [_c('div', {
    staticClass: "supplement-types__header__left"
  }, [(!_vm.isInOpusModal) ? _c('Tabs', {
    attrs: {
      "tabs": _vm.supplementTabs,
      "selected": _vm.selectedTab
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }) : _c('Tabs', {
    attrs: {
      "tabs": _vm.stateTabs,
      "selected": _vm.stateFilter
    },
    on: {
      "select": function($event) {
        _vm.stateFilter = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isDownloading
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownloadSimple
    }
  }, [_vm._v("\n        Download til excel\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "supplement-types__header__left"
  }, [(_vm.response.length > 0) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowResponseModal = true
      }
    }
  }, [_vm._v("Vis status")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === '(Lønbrøk)') ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'lønbrøk'
    },
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('lønbrøk')
      }
    }
  }, [_vm._v("\n        Hent lønbrøk\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'undervisningstillæg') ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'undervisningstillæg'
    },
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('undervisningstillæg')
      }
    }
  }, [_vm._v("\n        Hent UV-tillæg\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'undervisningstillæg') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowUvLimitsModal = true
      }
    }
  }, [_vm._v("\n        Se og rediger UV-grænser\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'specialskoletillæg') ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'specialskoletillæg'
    },
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('specialskoletillæg')
      }
    }
  }, [_vm._v("\n        Hent spec-skole UV-tillæg\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'specialskoletillæg') ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowUvLimitsModal = true
      }
    }
  }, [_vm._v("\n        Se og rediger UV-grænser\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isGeneratingSupplementType === 'opgaver'
    },
    on: {
      "click": function($event) {
        return _vm.generateSalarySupplements('opgaver')
      }
    }
  }, [_vm._v("\n        Hent opgaver med lønkoder\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'opgaver') ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.setIsShowTasksModal(true)
      }
    }
  }, [_vm._v("\n        Tilføj lønkode til opgaver\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
    staticClass: "do-table",
    class: {
      'do-table--fixed': _vm.isInOpusModal
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    class: {
      'td-identitet': _vm.isInOpusModal
    }
  }, [_vm._v(_vm._s(_vm.isInOpusModal ? 'Ansættelse' : 'Identitet'))]), _vm._v(" "), _c('th', [_vm._v("Brutto årsnorm")]), _vm._v(" "), _c('th', {
    staticClass: "width-period"
  }, [_vm._v("Beregningsperiode")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Omkostningssted")]), _vm._v(" "), _c('th', [_vm._v("Enheder i periode")]), _vm._v(" "), _c('th', [_vm._v("Antal udbetalinger")]), _vm._v(" "), _c('th', [_vm._v("Enh. pr måned")]), _vm._v(" "), (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Status")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.supplementsFiltered.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? 10 : 9
    }
  }, [_c('i', [_vm._v("Ingen oprettet i skoleåret")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.supplementsFiltered), function(supplement) {
    return _c('tr', {
      key: supplement.id,
      staticClass: "supplement-list-item",
      class: {
        'supplement-list-item--locked': _vm.isInOpusModal && _vm.stateFilter === 'done'
      },
      on: {
        "click": function($event) {
          return _vm.setEditSupplement(supplement)
        }
      }
    }, [_c('td', [_vm._v("\n          " + _vm._s(supplement.vUserName) + "\n        ")]), _vm._v(" "), (_vm.isInOpusModal) ? _c('td', {
      staticClass: "td-identitet",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.stateFilter === 'done') ? [_c('p', {
      staticClass: "employment-selected"
    }, [_vm._v(_vm._s(_vm.selectedEmploymentLabel(supplement)))])] : [_c('select', {
      staticClass: "do-select",
      attrs: {
        "disabled": _vm.savingEmploymentIds.includes(supplement.id)
      },
      domProps: {
        "value": supplement.employment_id || ''
      },
      on: {
        "change": function($event) {
          return _vm.onSelectEmployment(supplement, $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _vm._l((_vm.selectableEmploymentsForUser(supplement.user_id)), function(emp) {
      return _c('option', {
        key: emp.id,
        domProps: {
          "value": emp.id
        }
      }, [_vm._v("\n                " + _vm._s(_vm.employmentLabel(emp)) + "\n              ")])
    })], 2), _vm._v(" "), (_vm.selectableEmploymentsForUser(supplement.user_id).length === 0) ? _c('span', {
      staticClass: "employment-select__empty"
    }, [_vm._v("\n              Ingen ansættelse med stillingskategori\n            ")]) : _vm._e()]], 2) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.year_norm_hours))]), _vm._v(" "), _c('td', {
      staticClass: "width-period"
    }, [_vm._v(_vm._s(_vm.formatPeriod(supplement.valid_period)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.salaryCodeDisplay(supplement)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.costCenterDisplay(supplement)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.installments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDecimal(supplement.units_per_installment)))]), _vm._v(" "), (_vm.isInOpusModal && _vm.isSalaryIntegrationActive) ? _c('td', [_c('span', {
      staticClass: "supplement-state",
      class: 'supplement-state--' + (supplement.state || 'draft')
    }, [_vm._v("\n            " + _vm._s(_vm.stateLabel(supplement.state)) + "\n          ")])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), (_vm.isCreateModal) ? _c('CreateSupplement', {
    attrs: {
      "isSubmitting": _vm.isSubmitting,
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "schoolYear": _vm.schoolYear,
      "editSupplement": _vm.editSupplement,
      "isInOpusModal": _vm.isInOpusModal
    },
    on: {
      "save": _vm.createSupplement,
      "update": _vm.updateSupplement,
      "close": function($event) {
        return _vm.setIsCreateModal(false)
      },
      "delete": _vm.deleteSupplement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTasksModal) ? _c('TaskOverviewSettings', {
    attrs: {
      "isSupplements": true
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowTasksModal(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowResponseModal) ? _c('ShowResponse', {
    attrs: {
      "users": _vm.response
    },
    on: {
      "close": function($event) {
        _vm.isShowResponseModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowUvLimitsModal) ? _c('UvLimitsModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId
    },
    on: {
      "supplement-created": _vm.readSupplements,
      "close": function($event) {
        _vm.isShowUvLimitsModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1056088!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/SupplementsList.vue
// module id = 2159
// module chunks = 1